import { Col, Form, Row } from "antd";
import { useCallback, useState } from "react";
import { FloatNumberInput } from "../../../components/FloatNumberInput";
import { useGetInitialData } from "./hooks/useGetInitialData";
import { CheckOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import { useUpdate } from "./hooks/useUpdate";
import { useRules } from "./hooks/useRules";

export const FormContainer = () => {
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const [form] = Form.useForm();

  const { isLoading, initialValue, setInitialValue } = useGetInitialData(form);

  const enableEdit = useCallback(() => setIsEdit(true), []);

  const onCloseEdit = useCallback(() => {
    setIsEdit(false);
    form.setFieldValue("nextContractNumber", initialValue);
  }, [form, initialValue]);

  const { isSaving, update } = useUpdate(form, setIsEdit, setInitialValue);

  const { rules } = useRules();

  return (
    <Form form={form} className="h-100 d-flex mt-1" disabled={isSaving}>
      {!isEdit ? (
        <Row
          className={`position-relative align-center contract-number__container ${
            isLoading ? "" : "hoverable"
          }`}
          onClick={enableEdit}
        >
          <p className="my-0 text-md value elipsis logo-cursor">
            {initialValue}
          </p>
          <EditOutlined className="ml-1 edit-btn logo-cursor" />
        </Row>
      ) : (
        <Row className="w-100">
          <Col span={18}>
            <FloatNumberInput
              name="nextContractNumber"
              label=""
              className="mb-0 w-100"
              form={form}
              prefix=""
              rules={rules}
            />
          </Col>

          <Col span={6} className="mt-1">
            <CheckOutlined
              className="ml-2 ant-btn-link logo-cursor"
              onClick={update}
            />
            <CloseOutlined
              className="ml-2 ant-btn-link logo-cursor"
              onClick={onCloseEdit}
            />
          </Col>
        </Row>
      )}
    </Form>
  );
};
